import { z } from 'zod';

export const DeviceTypeSchema = z.enum(['ios', 'android']);
